import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Paperclip, Trash2 } from "lucide-react";
import { fileUrl } from "@/lib/jobOptions";

export function HireDialog({ hireFor, setHireFor, hire, setHire, sendHire, uploading, uploadHireFile, removeHireBijlage }) {
  return (
    <Dialog open={!!hireFor} onOpenChange={(o) => !o && setHireFor(null)}>
      <DialogContent className="rounded-md">
        <DialogHeader>
          <DialogTitle className="font-display">Aanvraag sturen naar {hireFor?.name}</DialogTitle>
          <DialogDescription>Stuur een directe opdrachtaanvraag naar deze professional.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-xs font-bold text-slate-700">Onderwerp</Label>
            <Input data-testid="hire-titel" value={hire.titel} onChange={(e) => setHire({ ...hire, titel: e.target.value })} className="rounded-sm border-slate-300" placeholder="bv. Montage kozijnen project Zuid" />
          </div>
          <div>
            <Label className="text-xs font-bold text-slate-700">Bericht</Label>
            <Textarea data-testid="hire-bericht" value={hire.bericht} onChange={(e) => setHire({ ...hire, bericht: e.target.value })} className="rounded-sm border-slate-300" rows={4} placeholder="Beschrijf de opdracht en planning..." />
          </div>
          <div>
            <Label className="text-xs font-bold text-slate-700 mb-2 block">Bijlagen <span className="font-normal text-slate-400">(PDF, PNG of GIF)</span></Label>
            <div className="space-y-2">
              {hire.bijlagen.map((b) => (
                <div key={b.id} data-testid="hire-bijlage-item" className="flex items-center justify-between bg-slate-50 border border-slate-200 rounded-sm px-3 py-2">
                  <a href={fileUrl(b.id)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-slate-700 hover:text-orange-600 truncate">
                    <Paperclip className="w-3.5 h-3.5 flex-shrink-0" /> <span className="truncate">{b.naam}</span>
                  </a>
                  <button type="button" data-testid="remove-hire-bijlage-btn" onClick={() => removeHireBijlage(b.id)} className="text-slate-400 hover:text-red-600 flex-shrink-0 ml-2">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>
            <label className="mt-2 inline-flex items-center gap-2 cursor-pointer border border-dashed border-slate-300 rounded-sm px-4 py-2 text-sm font-semibold text-slate-600 hover:border-orange-400 hover:text-orange-600">
              <Paperclip className="w-4 h-4" />
              {uploading ? "Bezig met uploaden..." : hire.bijlagen.length ? "Nog een bestand toevoegen" : "Bestand toevoegen"}
              <input data-testid="hire-bijlage-input" type="file" accept=".pdf,.png,.gif,application/pdf,image/png,image/gif" onChange={uploadHireFile} disabled={uploading} className="hidden" />
            </label>
          </div>
        </div>
        <DialogFooter>
          <Button data-testid="send-hire-btn" onClick={sendHire} disabled={!hire.titel || !hire.bericht}
            className="bg-orange-500 hover:bg-orange-600 text-white rounded-sm font-bold w-full">
            Aanvraag versturen
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
